var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPtaBoxImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 117,
    viewBox: "0 0 119 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.5,
    cy: 19.5,
    r: 19.5,
    fill: "#FFDE32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.542 101.277C116.583 110.268 108.578 117 99 117H83.7504C81.3922 113.776 80 109.801 80 105.5C80 94.7305 88.7305 86 99.5 86C108.82 86 116.612 92.5379 118.542 101.277Z",
    fill: "#E5E5E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.53635 117C0.541388 114.185 0 111.156 0 108C0 93.0883 12.0883 81 27 81C41.9117 81 54 93.0883 54 108C54 111.156 53.4586 114.185 52.4636 117H44.8654C46.2309 114.295 47 111.237 47 108C47 96.9543 38.0457 88 27 88C15.9543 88 7 96.9543 7 108C7 111.237 7.76911 114.295 9.13458 117H1.53635Z",
    fill: "#102689"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtaBoxImage);
export default __webpack_public_path__ + "static/media/ptaBoxImage.cdbf66c2a04d78e3ddf9a26b548e79ad.svg";
export { ForwardRef as ReactComponent };